import { createContext } from 'react';

const ScrollLockManagerContext = /*#__PURE__*/createContext(undefined);

export { ScrollLockManagerContext };
